class SupportLinkService {
    /*
        TODO: Eventually this service should receive a base support URL passed over by the api.  This will then supply the
        support URL path before the article numbers.  this will likely be like
        https://cp.serverdata.net/KB/Article ...  then we'll switch this to simply use the ending prefix combined with that base
            (for everything but Standard Anymeeting support)
            so eventually becomes   'portalsEmailNew': '38863' and we tack on the base passed over by the API.  Note:  we
            won't be able to do this for support links in the total error case.  that will still need to be determined
            by host domain
    */
    constructor(brandingService, supportLinkUpgradedService, subscriptionService) {
        this.supportLinkUpgradedService = supportLinkUpgradedService;

        this.supportLinks = {};
        this.privacyPolicyLink = '';

        this.rootSubscription = subscriptionService.createSubscription();
        this.subscribeToState();
    }

    getSupportLink(linkKey) {
        return this.supportLinks.hasOwnProperty(linkKey) ? this.supportLinks[linkKey] : this.supportLinks.generic;
    }

    getPrivacyPolicyLink() {
        return this.privacyPolicyLink;
    }

    subscribeToState() {
        this.rootSubscription.add(
            this.supportLinkUpgradedService.links$.subscribe(next => {
                this.supportLinks = next;
            })
        );

        this.rootSubscription.add(
            this.supportLinkUpgradedService.privacyPolicyLink$.subscribe(next => {
                this.privacyPolicyLink = next;
            })
        );
    }
}

firebird.factory('supportLinkService', [
    'brandingService',
    'supportLinkUpgradedService',
    'subscriptionService',
    (...deps) => new SupportLinkService(...deps)
]);
